module.exports = __webpack_public_path__ + "img/plan_default_big.4c4b99e2.jpg";